import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MAIN_SITE_URL } from '@/mocks/categories';

const faqItems = [
  { qKey: 'faq_q1', aKey: 'faq_a1' },
  { qKey: 'faq_q2', aKey: 'faq_a2' },
  { qKey: 'faq_q3', aKey: 'faq_a3' },
  { qKey: 'faq_q4', aKey: 'faq_a4' },
  { qKey: 'faq_q5', aKey: 'faq_a5' },
  { qKey: 'faq_q6', aKey: 'faq_a6' },
  { qKey: 'faq_q7', aKey: 'faq_a7' },
];

export default function FaqSection() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <>
      <section id="faq" className="scroll-mt-20">
        <div className="mx-auto max-w-4xl px-4 py-12 md:px-6 md:py-16">
          <div className="text-center">
            <h2 className="text-2xl font-bold text-foreground-950 md:text-3xl">{t('faq_title')}</h2>
            <p className="mx-auto mt-3 max-w-2xl text-base text-foreground-600">{t('faq_subtitle')}</p>
          </div>

          <div className="mt-8 space-y-3">
            {faqItems.map((item, index) => {
              const isOpen = openIndex === index;
              return (
                <div
                  key={item.qKey}
                  className="overflow-hidden rounded-lg border border-background-200 bg-white"
                >
                  <button
                    type="button"
                    onClick={() => setOpenIndex(isOpen ? null : index)}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                  >
                    <span className="text-sm font-semibold text-foreground-900 md:text-base">
                      {t(item.qKey)}
                    </span>
                    <span className="flex h-5 w-5 shrink-0 items-center justify-center text-primary-500">
                      <i className={`text-lg ${isOpen ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                    </span>
                  </button>
                  {isOpen && (
                    <div className="border-t border-background-100 px-5 py-4">
                      <p className="text-sm leading-relaxed text-foreground-600">{t(item.aKey)}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="bg-primary-500">
        <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
          <div className="mx-auto max-w-3xl text-center">
            <h2 className="text-2xl font-bold text-white md:text-4xl">{t('final_title')}</h2>
            <p className="mt-4 text-base leading-relaxed text-white/90">{t('final_body')}</p>
            <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <a
                href={MAIN_SITE_URL}
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 rounded-full bg-white px-6 py-3 text-base font-semibold text-primary-700 transition-colors hover:bg-background-100 cursor-pointer whitespace-nowrap"
              >
                {t('final_cta_primary')}
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-arrow-right-up-line text-sm"></i>
                </span>
              </a>
              <a
                href={MAIN_SITE_URL}
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 rounded-full border border-white/60 px-6 py-3 text-base font-semibold text-white transition-colors hover:bg-white/10 cursor-pointer whitespace-nowrap"
              >
                {t('final_cta_secondary')}
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-arrow-right-up-line text-sm"></i>
                </span>
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}